<template>
  <div>
    <!-- Tasks table -->
    <div class="card questions mt-3"
         qid="questions-section"
         id="update_task"
    >
      <div class="card-body" style="overflow-x:auto;">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="tasks-table-title">
                {{ $t('tasks.incident_category.tasks_label') }}
              </h5>
            </div>

          </div>
          <div class="col-sm-6 text-right">
            <button class="btn btn-success ml-3 pl-3 pr-3"
                    @click="showCreateRRModal()"
                    qid="question-create-button"
                    v-if="isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('system.add') }}
            </button>
          </div>
        </div>

        <table class="table table-responsive-md table-drag-and-drop">
          <thead>
            <tr>
              <th scope="col" width="50">

              </th>
              <th scope="col" width="350">
                {{ $t('maintenance.questions.create.name_label') }}
              </th>
              <th scope="col" width="150">
                {{ $t('maintenance.questions.table.type') }}
              </th>
              <th scope="col" width="250">
                {{ $t('maintenance.questions.table.dependencies') }}
              </th>
              <th width="130"></th>
            </tr>
          </thead>
          <draggable v-model="tableItems" :force-fallback="true" @start="drag=true" @end="drag=false" tag="tbody" @change="postOrder">
            <tr v-for="(object, index) in tableItems"
                :key="object.id"
                :id="'table-row-task-' + index"
                :class="{'alert-danger': object.dependency_task && object.order < object.dependency_task.order}"
            >
              <b-tooltip
                  v-if="object.dependency_task && object.order < object.dependency_task.order"
                  ref="tooltip"
                  :target="'table-row-task-' + index"
              >
                {{ $t('maintenance.questions.table.wrong_order_task_label') }}
              </b-tooltip>
              <td style="cursor: move;" class="text-center" width="50">
                <font-awesome-icon icon="arrows-alt" />
              </td>
              <td width="350">
                <span v-if="object && object.name">
                  {{ object.name }}
                </span>
              </td>
              <td width="150">
                <span v-if="object.response_type">
                  <span class="badge badge-info">
                    {{ $t('maintenance.questions.type.' + $options.filters.slugify(object.response_type)) }}
                  </span>
                </span>
              </td>
              <td width="250">
                <span v-if="object && object.dependency_task && object.dependency_task.name">
                  {{ object.dependency_task.name }}
                </span>
              </td>
              <td class="text-right">
                <span class="btn btn-edit"
                      qid="edit-v-modal"
                      v-if="isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
                      @click="showEditRRModal(object)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <button class="btn btn-delete"
                        qid="delete-question-modal"
                        v-if="isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
                        @click="showRRConfirmDeleteModal(object)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </td>
            </tr>
            <tr v-if="!loading && !tableItems.length" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </draggable>
        </table>
        <br>

      </div>
    </div>


    <!-- Delete retention rule modal template -->
    <b-modal ref="delete-question" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-question-title">
          {{ $t('maintenance.questions.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.description') }}
        <span v-if="itemToDelete && itemToDelete.name">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideRRConfirmDeleteModal"
                  qid="delete-question-cancel-button"
        >
          {{ $t('maintenance.questions.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteRR(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-question-submit-button"
        >
          {{ $t('maintenance.questions.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Add new task -->
    <b-modal ref="add-task" @hide="hideCreateRRModal" modal-class="task-modal mapping-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateRRModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('tasks.incident_category.create_modal_title') }}
          </h5>
        </div>
      </template>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formSubmit" qid="create-ac-form">

        <div class="form-container">

          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.incidents.incident_categories.tasks.task_title_label') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.incidents.incident_categories.tasks.task_title_description') }}
            </span>
          </div>

          <b-form-group>
            <label for="">
              {{ $t('maintenance.incidents.incident_categories.tasks.responsibles_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="selectedUsers"
                :options="users"
                :multiple="true"
                :taggable="false"
                @search-change="loadUsers"
                select-label="✔"
                selected-label="✔"
                deselect-label="x"
                track-by="slug"
                :placeholder="$t('maintenance.incidents.incident_categories.responsibles.responsibles_label')"
                label="name"
                qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('maintenance.questions.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-v-form-name"
              type="text"
              v-model="form.name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('maintenance.questions.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
              qid="create-v-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-rr-attachments-label">
              {{ $t('maintenance.retention_rules.create.attachments') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </label>
            <br>
            <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
            <label class="btn btn-secondary cursor-pointer" qid="create-rr-attachments-button">
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file-rr"
                     @change="onFileChange"
                     @click="resetFile"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('attachments.upload_button') }}
              </span>
            </label>
          </b-form-group>
          <b-form-group>
            <label qid="create-tp-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>
            <p v-for="(link, index) in form.links">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeLinkItem(index)"
                    qid="create-tp-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
            </p>
            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="handleLink"
                  qid="create-tp-add-link"
            >
              + {{ $t('system.add_link') }}
            </span>
          </b-form-group>

          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.answer_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.answer_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                group-values="items"
                group-label="group"
                :group-select="false"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                @select="handleType"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            >
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="text" v-if="props.option.value == 'Single line text'"/>
                <font-awesome-icon icon="text" v-if="props.option.value == 'Multi line text'"/>
                <font-awesome-icon icon="calendar-alt" v-if="props.option.value == 'Datepicker'"/>
                <font-awesome-icon icon="paperclip" v-if="props.option.value == 'Attachment'"/>
                <font-awesome-icon icon="list-alt" v-if="props.option.value == 'Dropdown'"/>
                <font-awesome-icon icon="clipboard-list" v-if="props.option.value == 'Yes/No'"/>
                <font-awesome-icon icon="desktop" v-if="props.option.value == 'System'"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="text" v-if="props.option.value == 'Single line text'"/>
                <font-awesome-icon icon="text" v-if="props.option.value == 'Multi line text'"/>
                <font-awesome-icon icon="calendar-alt" v-if="props.option.value == 'Datepicker'"/>
                <font-awesome-icon icon="paperclip" v-if="props.option.value == 'Attachment'"/>
                <font-awesome-icon icon="list-alt" v-if="props.option.value == 'Dropdown'"/>
                <font-awesome-icon icon="clipboard-list" v-if="props.option.value == 'Yes/No'"/>
                <font-awesome-icon icon="desktop" v-if="props.option.value == 'System'"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && (responseType.value == 'Dropdown' || responseType.value == 'System')">
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.select_type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="selectType"
                :options="selectTypes"
                :placeholder="$t('maintenance.questions.create.select_type_placeholder')"
                label="name"
                :allow-empty="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Dropdown'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions" class="mt-1 mb-1 pb-3 pt-3">
              <span class="float-right btn btn-delete"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <multiselect
                  v-model="option.value"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2">{{ option.title }}</span>
            </p>
            <div class="input-group pt-2">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Yes/No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="yesValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <div class="mt-2">Yes</div>
            </p>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="noValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <div class="mt-2">No</div>
            </p>
          </b-form-group>

          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value == 'Dropdown'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value == 'Yes/No'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>

          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.dependency_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.dependency_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.question_label') }}
            </label>
            <multiselect
                v-model="selectedQuestionDependency"
                :options="filteredTableItems"
                :placeholder="$t('maintenance.questions.create.question_placeholder')"
                label="name"
                @select="handleAnswers"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="selectedQuestionDependency && selectedQuestionDependency.id && answers && answers.length">
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.answers_label') }}
            </label>
            <multiselect
                v-model="selectedAnswers"
                :options="answers"
                :multiple="true"
                :taggable="false"
                :placeholder="$t('maintenance.questions.create.answers_placeholder')"
                label="title"
                track-by="value"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-2 mb-2"
                            variant="secondary"
                            @click="hideCreateRRModal"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('maintenance.questions.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="mt-2 mb-2 ml-3 mr-0"
                            :disabled="buttonDisabled"
                            variant="success"
                            @click="formSubmit()"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-modal>


    <!-- Edit task -->
    <b-modal ref="edit-task" @hide="hideEditRRModal" modal-class="task-modal mapping-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditRRModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('maintenance.incidents.incident_categories.tasks.update_modal_title') }}
          </h5>
        </div>
      </template>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editFormSubmit" qid="create-ac-form">
        <div class="form-container">

          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.incidents.incident_categories.tasks.task_title_label') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.incidents.incident_categories.tasks.task_title_description') }}
            </span>
          </div>

          <b-form-group>
            <label for="">
              {{ $t('maintenance.incidents.incident_categories.tasks.responsibles_label') }}
            </label>
            <multiselect
                v-model="selectedUsers"
                :options="users"
                :multiple="true"
                :taggable="false"
                @search-change="loadUsers"
                select-label="✔"
                selected-label="✔"
                deselect-label="x"
                track-by="slug"
                :placeholder="$t('maintenance.incidents.incident_categories.responsibles.responsibles_label')"
                label="name"
                qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('maintenance.questions.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-v-form-name"
              type="text"
              v-model="form.name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('maintenance.questions.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
              qid="create-v-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-rr-attachments-label">
              {{ $t('maintenance.retention_rules.create.attachments') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </label>
            <br>
            <p v-for="file in selectedQuestion.media">
              <span class="float-right text-muted cursor-pointer"
                    @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a @click="downloadMedia(file)" qid="create-p-media-item">
                {{ file.file_name }}
              </a>
            </p>
            <label class="btn btn-secondary cursor-pointer"
                   qid="create-p-file-button"
            >
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file"
                     @change="onFileChangeEdit"
                     @click="resetFileEdit"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('system.upload') }}
              </span>
            </label>
          </b-form-group>
          <b-form-group>
            <label qid="create-tp-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>
            <div v-if="selectedQuestion.links">
              <p v-for="link in selectedQuestion.links" >
                <span class="float-right text-muted cursor-pointer"
                      @click="openDeleteLinkModal(link)"
                      qid="view-p-remove-link"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-p-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
            <div v-if="showInput">
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer"
                  @click="showInput = true"
                  qid="add-another-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
            </span>
          </b-form-group>

          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.answer_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.answer_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                group-values="items"
                group-label="group"
                :group-select="false"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
                @select="handleType"
            >
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="text" v-if="props.option.value == 'Single line text'"/>
                <font-awesome-icon icon="text" v-if="props.option.value == 'Multi line text'"/>
                <font-awesome-icon icon="calendar-alt" v-if="props.option.value == 'Datepicker'"/>
                <font-awesome-icon icon="paperclip" v-if="props.option.value == 'Attachment'"/>
                <font-awesome-icon icon="list-alt" v-if="props.option.value == 'Dropdown'"/>
                <font-awesome-icon icon="clipboard-list" v-if="props.option.value == 'Yes/No'"/>
                <font-awesome-icon icon="desktop" v-if="props.option.value == 'System'"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="text" v-if="props.option.value == 'Single line text'"/>
                <font-awesome-icon icon="text" v-if="props.option.value == 'Multi line text'"/>
                <font-awesome-icon icon="calendar-alt" v-if="props.option.value == 'Datepicker'"/>
                <font-awesome-icon icon="paperclip" v-if="props.option.value == 'Attachment'"/>
                <font-awesome-icon icon="list-alt" v-if="props.option.value == 'Dropdown'"/>
                <font-awesome-icon icon="clipboard-list" v-if="props.option.value == 'Yes/No'"/>
                <font-awesome-icon icon="desktop" v-if="props.option.value == 'System'"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && (responseType.value == 'Dropdown' || responseType.value == 'System')">
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.select_type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="selectType"
                :options="selectTypes"
                :placeholder="$t('maintenance.questions.create.select_type_placeholder')"
                label="name"
                :allow-empty="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Dropdown'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions" class="mt-1 mb-1 pb-3 pt-3">
              <span class="float-right btn btn-delete"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <multiselect
                  v-model="option.value"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2 display-inline-block">{{ option.title }}</span>
            </p>
            <div class="input-group pt-2">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Yes/No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="yesValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2 display-inline-block">Yes</span>
            </p>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="noValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'" style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="props.option.value == 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="props.option.value == 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2 display-inline-block">No</span>
            </p>
          </b-form-group>

          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value == 'Dropdown'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value == 'Yes/No'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>

          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.dependency_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.dependency_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.question_label') }}
            </label>
            <multiselect
                v-model="selectedQuestionDependency"
                :options="dependantQuestionItems"
                :placeholder="$t('maintenance.questions.create.question_placeholder')"
                label="name"
                @select="handleAnswers"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="selectedQuestionDependency && selectedQuestionDependency.id && answers && answers.length">
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.answers_label') }}
            </label>
            <multiselect
                v-model="selectedAnswers"
                :options="answers"
                :multiple="true"
                :taggable="false"
                :placeholder="$t('maintenance.questions.create.answers_placeholder')"
                label="title"
                track-by="value"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-2 mb-2"
                            variant="secondary"
                            @click="hideEditRRModal"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('maintenance.questions.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="mt-2 mb-2 ml-3 mr-0"
                            :disabled="buttonDisabled"
                            variant="success"
                            @click="editFormSubmit()"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import draggable from 'vuedraggable'
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';

  export default {
    name: 'TasksTable',
    data: function() {
      return {
        form: {
          name: '',
          description: '',
          links: []
        },
        responseType: [],
        selectType: [],
        addDescription: [],
        addAttachments: [],

        error: '',
        tableItems: [],
        filteredTableItems: [],
        loading: true,
        itemToDelete: {},
        buttonDisabled: false,
        dependantQuestionItems: [],

        responseTypes: [
          {
            group: this.$t('maintenance.questions.answer_type.input_label'),
            items: [
              { name: this.$t('maintenance.questions.type.single_line_text'), value:'Single line text' },
              { name: this.$t('maintenance.questions.type.multi_line_text'), value:'Multi line text' },
              { name: this.$t('maintenance.questions.type.datepicker'), value: 'Datepicker' },
              { name: this.$t('maintenance.questions.type.attachment'), value: 'Attachment' }
            ]
          },
          {
            group: this.$t('maintenance.questions.answer_type.dropdown_label'),
            items: [
              { name: this.$t('maintenance.questions.type.dropdown'), value: 'Dropdown'},
              { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No'}
            ]
          },
          {
            group: this.$t('maintenance.questions.answer_type.assets_label'),
            items: [
              { name: this.$t('maintenance.questions.type.system'), value: 'System' }
            ]
          },
        ],
        allowTypes: [
          { name: this.$t('maintenance.questions.type.no'), value: 'No' },
          { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
          { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
        ],
        selectTypes: [
          { name: this.$t('maintenance.questions.select_type.single'), value: 'Single select' },
          { name: this.$t('maintenance.questions.select_type.multi'), value: 'Multi select' },
        ],
        answerTypes: [
          {
            group: this.$t('maintenance.questions.answer_type.positive_negative_label'),
            items: [
              { name: this.$t('maintenance.questions.answer_type.neutral'), value: 'Neutral' },
              { name: this.$t('maintenance.questions.answer_type.positive'), value: 'Positive' },
              { name: this.$t('maintenance.questions.answer_type.negative'), value: 'Negative' },
            ]
          },
          {
            group: this.$t('maintenance.questions.answer_type.impact_assessment_label'),
            items: [
              { name: this.$t('maintenance.questions.answer_type.very_low'), value: 'Very low' },
              { name: this.$t('maintenance.questions.answer_type.low'), value: 'Low' },
              { name: this.$t('maintenance.questions.answer_type.high'), value: 'High' },
              { name: this.$t('maintenance.questions.answer_type.very_high'), value: 'Very high' },
            ]
          },
        ],
        yesNoOptions: [
          'Yes',
          'No'
        ],
        yesValue: [],
        noValue: [],
        selectedOptions: [],
        inputOption: '',
        positiveAnswers: [],
        negativeAnswers: [],
        allAnswers: [],
        allAnswersCopy: [],
        selectedQuestion: [],
        showInput: true,
        showOptionInput: true,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        showAttachments: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,

        questions: [],
        selectedUsers: [],
        users: [],
        selectedQuestionDependency: [],
        selectedAnswers: [],
        answers: [],
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      tasks: {
        type: Array
      },
      guides: {
        type: Array
      }
    },
    components: {
      Avatar,
      draggable,
      ConfirmRemoveAttachment
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadUsers()
      },
      object: function (value) {
        this.incident = value
        this.loadTasks();
      },
      selectedOptions: function (value) {
        let self = this
        this.allAnswers = value
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        _.forEach(this.positiveAnswers, function (answer) {
          self.handleAvailableAnswers(answer)
        })
        _.forEach(this.negativeAnswers, function (answer) {
          self.handleAvailableAnswers(answer)
        })
      }
    },
    methods: {
      handleType(value) {
        this.positiveAnswers = []
        this.negativeAnswers = []
        if (value && value.value == 'Dropdown') {
          this.selectType = this.selectTypes[0]
          this.allAnswers = this.selectedOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.noValue = this.answerTypes[0].items[0]
          this.yesValue = this.answerTypes[0].items[0]
          this.allAnswers = this.yesNoOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      },
      handleAnswers(question) {
        this.answers = []
        let self = this;

        if (question.response_type_options) {
          let array = JSON.parse(question.response_type_options)
          _.forEach(array, function (item, index) {
            self.answers.push({
              title: item.title,
              value: item.title,
            });
          })
        }

      },
      handleOption(evt) {
        evt.preventDefault();
        // If there's a link in input, add it to links array
        if (this.inputOption !== '') {
          this.selectedOptions.push({title: this.inputOption, value: this.answerTypes[0].items[0]})
          // Reset link input form
          this.inputOption = ''
        }
        this.showOptionInput = false;
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadQuestion();
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadQuestion();
      },
      handleEditLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'))
          self.loadQuestion()
          self.inputLink = ''
          self.inputLinkName = ''
          self.showInput = false
        }, function() {})
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChangeEdit(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'))
            self.error = ''
            self.loadQuestion()
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      resetFile() {
        let imagefile = document.querySelector('#file-rr');
        imagefile.value = '';
      },
      resetFileEdit() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file-rr');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      removeOptionItem(index, item) {
        let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer == item })
        let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer == item })

        this.selectedOptions.splice(index, 1);

        if (!this.selectedOptions.length) {
          this.showOptionInput = true;
        }
      },
      handleAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index != -1) {
          this.allAnswersCopy.splice(index, 1)
        }
      },
      expandAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index == -1) {
          this.allAnswersCopy.push(answer)
        }
      },
      showCreateRRModal() {
        let self = this;

        this.selectedUsers = [];
        _.forEach(this.incident.users, function (user) {
          self.selectedUsers.push(user)
        })

        this.$refs['add-task'].show()
      },
      hideCreateRRModal() {
        this.error = ''
        this.selectedOptions = []
        this.inputOption = ''
        this.responseType = []
        this.selectType = []
        this.selectedUsers = []
        this.noValue = []
        this.yesValue = []
        this.selectedQuestionDependency = []
        this.selectedAnswers = []
        this.showInput = true
        this.showOptionInput = true
        this.form.name = ''
        this.form.description = ''
        this.form.links = []
        this.selectedFiles = []
        this.$refs['add-task'].hide()
      },
      showEditRRModal(object) {
        let self = this;
        this.selectedQuestion = object;

        this.dependantQuestionItems = []
        _.forEach(self.filteredTableItems, function (question) {
          if (question.id != self.selectedQuestion.id) {
            self.dependantQuestionItems.push(question)
          }
        })

        this.responseType = []
        if (object.response_type) {
          this.responseType = _.find(this.responseTypes, function(item) {
            return item.value === object.response_type;
          });
        }

        this.selectedUsers = [];
        _.forEach(object.users, function (user) {
          self.selectedUsers.push(user)
        })

        this.selectType = []
        if (object.select_type) {
          this.selectType = _.find(this.selectTypes, function(item) {
            return item.value === object.select_type;
          });
        }

        this.selectedQuestionDependency = []
        if (object.dependency_task_id) {

          this.selectedQuestionDependency = _.find(this.tableItems, function(item) {
            return item.id === object.dependency_task_id;
          });

          this.handleAnswers(this.selectedQuestionDependency)

          if (object.dependency_task_answer) {
            _.forEach(object.dependency_task_answer, function (item, index) {
              self.selectedAnswers.push({
                title: item,
                value: item,
              });
            })
          }

        }

        if (this.selectedQuestion.response_type == 'Dropdown') {
          this.selectedOptions = []
          if (this.selectedQuestion.response_type_options) {
            let array = JSON.parse(this.selectedQuestion.response_type_options)
            this.selectedOptions.push(...array)
          }
        }

        if (this.selectedQuestion.response_type == 'Yes/No') {
          this.yesValue = []
          this.noValue = []
          if (this.selectedQuestion.response_type_options) {
            let array = JSON.parse(this.selectedQuestion.response_type_options)
            this.yesValue = array[0].value
            this.noValue = array[1].value
          }
        }

        this.form.slug = object.slug;
        this.form.name = object.name;
        this.form.description = object.description;
        this.$refs['edit-task'].show()
      },
      hideEditRRModal() {
        this.error = ''
        this.selectedOptions = []
        this.inputOption = ''
        this.responseType = []
        this.noValue = []
        this.yesValue = []
        this.selectType = []
        this.selectedQuestionDependency = []
        this.selectedAnswers = []
        this.selectedUsers = []
        this.showInput = true
        this.showOptionInput = true
        this.form.name = ''
        this.form.description = ''
        this.$refs['edit-task'].hide()
      },
      postOrder() {
        let self = this;
        let order = []
        _.forEach(this.tableItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });
        })
        piincHttp.post('incident-category-tasks/order', {
          incident_category_id: this.incident.id,
          order: order
        }).then(function(response) {
          self.loadTasks()
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      showRRConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-question'].show()
      },
      hideRRConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-question'].hide()
      },
      confirmDeleteRR(object) {
        let self = this;
        piincHttp.delete('incident-category-tasks/' + object.id).then(function() {
          self.hideRRConfirmDeleteModal();
          self.loadTasks();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.incidents.incident_categories.tasks.delete_success'))
        }, function() {});
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        let files = document.querySelector('#file-rr');
        let sizeError = false;

        this.handleLink()

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        if (evt) {
          evt.preventDefault();
        }

        formData.append("incident_category_id", this.incident.id);
        formData.append("name", this.form.name);
        formData.append("description", this.form.description);

        if (this.responseType && this.responseType.value) {
          formData.append("response_type", this.responseType.value);
        }

        if (this.selectType && this.selectType.value) {
          formData.append("select_type", this.selectType.value);
        }

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
          if (files.files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", files.files[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.form.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.form.links[i]));
        }

        if (this.responseType && this.responseType.value && this.responseType.value == 'Yes/No') {
          let array = [
            {title: 'Yes', value: this.yesValue},
            {title: 'No', value: this.noValue},
          ]
          formData.append("response_type_options", JSON.stringify(array))
        }

        if (this.responseType && this.responseType.value && this.responseType.value == 'Dropdown') {
          if (this.selectedOptions && this.selectedOptions.length) {
            formData.append("response_type_options", JSON.stringify(this.selectedOptions))
          }
        }

        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            formData.append("users[]", this.selectedUsers[i].id);
          }
        }

        if (this.selectedQuestionDependency && this.selectedQuestionDependency.id) {
          formData.append("dependency_task_id", this.selectedQuestionDependency.id);
          for (var i = 0; i < this.selectedAnswers.length; i++) {
            formData.append("dependency_task_answer[]", this.selectedAnswers[i].title);
          }
        } else {
          formData.append("dependency_task_id", '');
        }

        if (sizeError) {
          this.error = this.$t('system.file_size')
          this.buttonDisabled = false;
        } else {

          this.buttonDisabled = true;

          if (this.responseType && this.responseType.value &&
            ((this.responseType && this.responseType.value != 'Dropdown') || (this.responseType && this.responseType.value == 'Dropdown' && this.selectedOptions && this.selectedOptions.length)) &&
            this.form.name && this.form.description
          ) {
            piincHttp.post('incident-category-tasks', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('maintenance.incidents.incident_categories.tasks.create_success'))
              self.hideCreateRRModal();
              self.loadTasks();
              self.$emit('updated');
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
                if (error.data.errors['files.0']) {
                  self.error += ' ' + error.data.errors['files.0'][0]
                }
              }
            })
          } else {
            this.error = '';
            self.buttonDisabled = false;

            if (!this.form.name) {
              this.error += ' ' + this.$t('maintenance.questions.create.name_error_message')
            }
            if (!this.form.description) {
              this.error += ' ' + this.$t('maintenance.questions.create.description_error_message')
            }
            if (!this.responseType || (this.responseType && !this.responseType.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message')
            }
            if ((this.responseType && this.responseType.value == 'Dropdown') && this.selectedOptions && !this.selectedOptions.length) {
              this.error += this.$t('maintenance.questions.create.selected_options_error_message')
            }
          }
        }
      },
      editFormSubmit(evt) {
        this.buttonDisabled = true;

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        if (evt) {
          evt.preventDefault();
        }

        let form = {};

        form.name = this.form.name
        form.description = this.form.description

        if (this.responseType && this.responseType.value) {
          form.response_type = this.responseType.value
        }

        if (this.selectType && this.selectType.value) {
          form.select_type = this.selectType.value
        }

        form.users = []
        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            form.users.push(this.selectedUsers[i].id);
          }
        }

        if (this.responseType && this.responseType.value && this.responseType.value == 'Yes/No') {
          let array = [
            {title: 'Yes', value: this.yesValue},
            {title: 'No', value: this.noValue},
          ]
          form.response_type_options = JSON.stringify(array)
        }

        if (this.responseType && this.responseType.value && this.responseType.value == 'Dropdown') {
          if (this.selectedOptions && this.selectedOptions.length) {
            form.response_type_options = JSON.stringify(this.selectedOptions)
          } else {
            form.response_type_options = '[]'
          }
        }

        if (this.selectedQuestionDependency && this.selectedQuestionDependency.id) {
          form.dependency_task_id = this.selectedQuestionDependency.id
          form.dependency_task_answer = []
          for (var i = 0; i < this.selectedAnswers.length; i++) {
            form.dependency_task_answer.push(this.selectedAnswers[i].title)
          }
        } else {
          form.dependency_task_id = ''
        }

        if (this.responseType && this.responseType.value &&
          ((this.responseType && this.responseType.value != 'Dropdown') || (this.responseType && this.responseType.value == 'Dropdown' && this.selectedOptions && this.selectedOptions.length)) &&
          this.form.name && this.form.description
        ) {
          piincHttp.put('incident-category-tasks/' + this.selectedQuestion.id, form).then(function(response) {
            self.$toastr('success', self.$t('maintenance.incidents.incident_categories.tasks.update_success'))
            self.hideEditRRModal();
            self.loadTasks();
            self.$emit('updated');
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;

          if (!this.form.name) {
            this.error += ' ' + this.$t('maintenance.questions.create.name_error_message')
          }
          if (!this.form.description) {
            this.error += ' ' + this.$t('maintenance.questions.create.description_error_message')
          }
          if (!this.responseType || (this.responseType && !this.responseType.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message')
          }
          if ((this.responseType && this.responseType.value == 'Dropdown') && this.selectedOptions && !this.selectedOptions.length) {
            this.error += this.$t('maintenance.questions.create.selected_options_error_message')
          }
        }
      },
      loadQuestion() {
        let self = this;

        piincHttp.get('incident-category-tasks/' + this.selectedQuestion.id).then(function(response) {
          self.selectedQuestion.media = response.data.media
          self.selectedQuestion.links = response.data.links
        }, function() {});
      },
      loadTasks() {
        let self = this;

        piincHttp.get('incident-category-tasks', { params:
          {
            page: 1,
            per_page: 1,
            incident_category: this.incident.id
          }
        }).then(function(response) {
          let total = response.data.total_count

          piincHttp.get('incident-category-tasks', { params:
            {
              page: 1,
              per_page: total,
              incident_category: self.incident.id
            }
          }).then(function(response) {
            self.loading = false;
            self.tableItems = response.data.items;

            self.filteredTableItems = []
            _.forEach(self.tableItems, function (task) {
              if (task.response_type == 'Dropdown' || task.response_type == 'Yes/No') {
                self.filteredTableItems.push(task)
              }
            })

            // Set number of total items
            self.totalRows = response.data.total_count;
          }, function() {});
        }, function() {});
      },
      loadUsers(query) {
        let self = this;
        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 50
          }
        }).then(function(response) {
          self.users = response.data.items
        }, function() {});
      },
      loadContent() {
        let self = this;
        piincHttp.get('incident-categories/' + this.$route.params.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.incident = response.data;
        }, function() {});
      },
    },
    created () {
      this.incident = this.object
      if (this.getClient && this.getClient.slug) {
        this.loadUsers()
      }

      if (this.incident && this.incident.id) {
        // Table items
        this.loadTasks();
      }

    }
  }
</script>
